import React from "react"
import { IconImage, InfoBoxContainer, InfoBoxWrapper } from "../../styles"
import infoIcon from "../../icons/info-icon.svg"

export default function InfoBox(props) {
  return (
    <InfoBoxWrapper>
      <InfoBoxContainer>
        <IconImage src={infoIcon} alt="Info icon" />
      </InfoBoxContainer>
      <InfoBoxContainer>{props.children}</InfoBoxContainer>
    </InfoBoxWrapper>
  )
}
